import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'
import {
  AirplaneIcon,
  BooksIcon,
  EmergencyPhoneIcon,
  FamilyThreeIcon,
  HomeIcon,
  PassportIcon,
  SuitCaseIcon
} from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

export * from './client-header'

export function LabelValue({
  label,
  children,
  color,
  className
}: {
  label: string
  children: React.ReactNode
  color?: string
  className?: string
}) {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <Typography variant={'label-medium'} color={color}>
        {label}
      </Typography>
      {children}
    </div>
  )
}

export type GuideDisplayKeys =
  | 'formalities'
  | 'preparation'
  | 'family-hostess'
  | 'daily-life'
  | 'trip'
  | 'courses-activities'
  | 'security-support'

type GuideItemType = {
  icon: SVGFC
  key: GuideDisplayKeys
  title: string
  description: string
}

export const getGuideItems: (displayOptions: GuideDisplayKeys[]) => GuideItemType[] = (
  displayOptions
) => {
  const items: GuideItemType[] = [
    {
      icon: PassportIcon,
      title: 'Formalités',
      key: 'formalities',
      description: "Papiers d'identité, santé, assurances."
    },
    {
      icon: SuitCaseIcon,
      title: 'Préparation',
      key: 'preparation',
      description: 'Valise, équipement, argent de poche.'
    },
    {
      icon: FamilyThreeIcon,
      title: 'Famille-hôtesse',
      key: 'family-hostess',
      description: 'Accueil, conseils de vie quotidienne.'
    },
    {
      icon: HomeIcon,
      title: 'Vie quotidienne',
      key: 'daily-life',
      description: 'Logement, repas, règles de vie.'
    },
    {
      icon: AirplaneIcon,
      title: 'Voyage',
      key: 'trip',
      description: 'Infos pratiques, bagages, rendez-vous.'
    },
    {
      icon: BooksIcon,
      title: 'Cours & activités',
      key: 'courses-activities',
      description: 'Programme, cahier journal, options sportives.'
    },
    {
      icon: EmergencyPhoneIcon,
      title: 'Sécurité & accompagnement',
      key: 'security-support',
      description: "Contacts utiles, numéro d\'urgence."
    }
  ]

  return items.filter((item) => displayOptions.includes(item.key))
}

export function GuideItem({ icon: Icon, title, description }: GuideItemType) {
  return (
    <div className={'flex flex-row gap-2 items-center'}>
      <div className={'w-10 h-10 bg-primary-light rounded flex items-center justify-center'}>
        <Icon className={'w-8 h-8'} color={tailwindColors.primary.DEFAULT} />
      </div>
      <div className={'flex flex-col gap-1'}>
        <Typography variant={'tag'}>{title}</Typography>
        <Typography variant={'secondary-body'}>{description}</Typography>
      </div>
    </div>
  )
}
